<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NoPkpH/tc-custom/9781453291283.jpg?1705379643403" alt="This image is the cover for the book Snark, The Clifford Driscoll Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Snark, The Clifford Driscoll Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>In the follow-up to <i>Cronus</i>, an American spy travels to London to locate a high-profile missing person, and is faced with terror from the past</b><br/>If they’re going to take you, let them take you with your eyes open. That’s the credo of Clifford Driscoll, the American spy at the center of <i>Snark</i>, the follow-up to William DeAndrea’s Edgar Award–winning <i>Cronus</i>. Driscoll has gone by many names in his short, eventful life, and he’s just borrowed another: that of Jeffrey Bellman, an agent his Russian enemies at Cronus consider dead. As the son of a formidable secret intelligence director, Driscoll/Bellman is used to all kinds of existential ducking and weaving.  The new Bellman is sent to England to find Sir Lewis Alfot, a missing former British intelligence chief. He hasn’t even left the London airport, though, before assassins target him. They come courtesy of Leo Calvin, a terrorist Bellman’s dealt with in the past—and Calvin has just kidnapped Alfot as bait. Can Bellman stop Calvin in his tracks, and is Alfot, for his part, as respectable and law-abiding as he seems? 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William L. DeAndrea
      </h2>
      
      <p class="authorDescription body article">William L. DeAndrea (1952&ndash;1996) was born in Port Chester, New York. While working at the Murder Ink bookstore in New York City, he met mystery writer Jane Haddam, who became his wife. His first book, <i>Killed in the Ratings</i> (1978), won an Edgar Award in the best first mystery novel category. That debut launched a series centered on Matt Cobb, an executive problem-solver for a TV network who unravels murders alongside corporate foul play. DeAndrea&rsquo;s other series included the Nero Wolfe&ndash;inspired Niccolo Benedetti novels, the Clifford Driscoll espionage series, and the Lobo Blacke/Quinn Booker Old West mysteries. A devoted student of the mystery genre, he also wrote a popular column for the<i> Armchair Detective</i> newsletter. One of his last works, the Edgar Award&ndash;winning <i>Encyclopedia Mysteriosa</i> (1994), is a thorough reference guide to sleuthing in books, film, radio, and TV.&#160; &#160; &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?27f17e04